module.exports = __webpack_public_path__ + "img/ca.8ca30f9.webp";